export const NAME = 'fees';

const CONTEXT = 'PDV::FEES';

const SERVICE_GET = `${CONTEXT}::SERVICE::GET`;
const SERVICE_GET_LINK = `${CONTEXT}::SERVICE::GET::LINK`;

const FETCH_START = `${CONTEXT}::FETCH::START`;
const FETCH_SUCCESS = `${CONTEXT}::FETCH::SUCCESS`;
const FETCH_SUCCESS_LINK = `${CONTEXT}::FETCH::SUCCESS::LINK`;
const FETCH_ERROR = `${CONTEXT}::FETCH::ERROR`;

const RESET_STATE = `${CONTEXT}::RESET::STATE`;

const RESET = {
  STATE: RESET_STATE,
};

const SERVICE = {
  GET: SERVICE_GET,
  GET_LINK: SERVICE_GET_LINK,
};

const FETCH = {
  START: FETCH_START,
  SUCCESS: FETCH_SUCCESS,
  SUCCESS_LINK: FETCH_SUCCESS_LINK,
  ERROR: FETCH_ERROR,
};

export const ACTION_TYPES = {
  RESET,
  SERVICE,
  FETCH,
};
